module.exports = __webpack_public_path__ + "img/android-pay.0354b491.png";